import { Heading, SimpleGrid, VStack } from "@chakra-ui/react";
import { FeatureCard, FROST, Pill, Reveal, Section, TEAL_DARK } from "./utils";
import { features } from "./data";

const Features = () => (
  <Section bg={FROST} id="features">
    <VStack gap={10}>
      <Reveal>
        <VStack gap={3} textAlign="center" maxW="500px" mx="auto">
          <Pill>Mit tartalmaz az ajánlat?</Pill>
          <Heading
            fontSize={{ base: "xl", md: "2xl" }}
            color={TEAL_DARK}
            letterSpacing="-0.02em"
          >
            Minden, ami kell. Semmi felesleges.
          </Heading>
        </VStack>
      </Reveal>
      <SimpleGrid columns={{ base: 1, sm: 2, lg: 3 }} gap={5} w="full">
        {features.map((f, i) => (
          <FeatureCard
            key={i}
            icon={f.icon}
            title={f.title}
            body={f.body}
            delay={i * 0.07}
          />
        ))}
      </SimpleGrid>
    </VStack>
  </Section>
);

export default Features;
